import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown, faCheck } from "@fortawesome/free-solid-svg-icons";

import '../styles/Dropdown.css';
import '../styles/Button.css';

import Config from "../Config";
import MetamodelStore from "../resources/data/MetamodelStore";
import StateGlobal from "../StateGlobal";

export default class Dropdown extends React.Component {
    constructor(props) {
        super(props);

        const savedSelection = localStorage.getItem(`${props.type}Selected`);

        this.state = {
            isListOpen: savedSelection ? false : this.props.openedAtCreation, // Collapse list if data exists
            headerTitle: savedSelection ? Config.getLangName(JSON.parse(savedSelection)) : this.props.title,
            sIconSelected: savedSelection ? MetamodelStore.getInstance().getIcon(JSON.parse(savedSelection).id) : null,
        };

        if(savedSelection) {
            if(this.props.type === "Model"){
                var sNameModel = Config.getLangName(JSON.parse(savedSelection));
                StateGlobal._isModelSelected = true;
                StateGlobal._modelSelected = sNameModel;
            }
            if(this.props.type === "Object"){
                var sNameObject = Config.getLangName(JSON.parse(savedSelection));
                StateGlobal._isObjectSelected = false;
                StateGlobal._objectSelected = sNameObject;
            }
            
        }

        Config.getConfig();
    }

    componentDidMount() {
        const savedSelection = localStorage.getItem(`${this.props.type}Selected`);
        if (savedSelection) {
            const parsedSelection = JSON.parse(savedSelection);
            this.props.resetThenSet(parsedSelection.id);  // Automatically refresh view with saved selection
        }
    }

    /**
     * Open and close dropdown list
     */
    toggleList = () => {
        this.setState(prevState => ({
            isListOpen: !prevState.isListOpen,
        }));
    }

    /**
     * Handle selection
     * @param {Object} item 
     */
    selectItem = (item, sType) => {
        try {
            var sIconSelected = MetamodelStore.getInstance().getIcon(item.id);
        } catch (err) {
            console.warn(err);
        }

        StateGlobal._currentBradCrumbs = [];

        if (sType === "Model") {
            StateGlobal._modelSelected = Config.getLangName(item);
            StateGlobal._isModelSelected = true;
            StateGlobal._isObjectSelected = false;
        }

        if (sType === "Object") {
            StateGlobal._objectSelected = Config.getLangName(item);
            StateGlobal._isModelSelected = false;
            StateGlobal._isObjectSelected = true;
        }

        // Save selection to local storage
        localStorage.setItem(`${sType}Selected`, JSON.stringify(item));

        this.setState({
            isListOpen: false,
            headerTitle: Config.getLangName(item),
            sIconSelected: sIconSelected
        },
            () => this.props.resetThenSet(item.id) // Call resetThenSet with item ID
        );
    }

    render() {
        const { itemsList, type } = this.props;
        const { isListOpen, headerTitle, sIconSelected } = this.state;

        return (
            <div className="Dropdown">

                <button
                    type="button"
                    onClick={this.toggleList}
                    className="Dropdown__button Dropdown__button--top"
                >
                    <div>
                        {sIconSelected && <img src={"data:image/png;base64," + sIconSelected} />}
                        {' '}
                        {headerTitle + ' '}
                        {isListOpen
                            ? <FontAwesomeIcon icon={faAngleUp} />
                            : <FontAwesomeIcon icon={faAngleDown} />}
                    </div>
                </button>

                {isListOpen && (
                    <div className="Dropdown__list">
                        {itemsList.map((item) => {
                            let sIconEncoded = null;
                            try {
                                sIconEncoded = MetamodelStore.getInstance().getIcon(item.id);
                            } catch (err) {
                                console.warn(err);
                            }
                            return (<div key={item.id}>
                                <button
                                    type="button"
                                    onClick={() => {
                                        this.selectItem(item, type);
                                    }}
                                    className={"Dropdown__button".concat(item.selected ? " Dropdown__button--selected" : "")}
                                >
                                    <img
                                        src={sIconEncoded ? ("data:image/png;base64," + sIconEncoded) : ""}
                                    />
                                    {' '}
                                    {Config.getLangName(item)}
                                    {' '}
                                    {item.selected && <FontAwesomeIcon icon={faCheck} />}
                                </button>
                            </div>)
                        })}
                    </div>
                )}

            </div>
        )
    }
}
